






































































































import LoadingCover from '@/components/globals/basics/Loading/LoadingCover.vue'
import MeLayout from '@/components/globals/MeLayout.vue'
import { getMe, MeResponse } from '@/core/Me'
import { PointSubscription } from '@/externals/gyym/user/pointSubscriptions'
import router from '@/router'
import store from '@/store'
import { PartialAuthUser } from '@/store/modules/auth/getters'
import { Meta } from '@/tools/page'
import Vue from 'vue'

const PAGE_TITLE = '定期購入の停止手続き'
const PAGE_META: Meta[] = []

export default Vue.extend({
  components: {
    MeLayout,
    LoadingCover,
  },
  data() {
    return {
      isLoading: true,
      me: {} as MeResponse,
      expiringPoints: 0,
    }
  },
  computed: {
    user(): PartialAuthUser {
      return this.$store.getters['auth/user']
    },
    subscription(): PointSubscription | null {
      return this.user.pointSubscription
    },
    isToLoseAllSubscriptionPointsAtCancel(): boolean {
      return this.subscription?.isToLoseAllSubscriptionPointsAtCancel ?? false
    },
    isSubscribedUser(): boolean {
      return this.$store.getters['auth/isSubscribed']
    },
  },
  beforeRouteEnter(_, from, next) {
    if (!store.getters['auth/user'].name) {
      if (from.matched.length === 0) {
        // プロフィール未登録の場合、この画面にはアクセスできないので直アクセスの場合施設一覧ページを挟ませる
        next('/facilities')
      }
      router.app.$modal.push('ProfileModal')
      next(false)
    } else {
      next()
    }
  },
  async created() {
    this.$setPageTitle(PAGE_TITLE)
    this.$setPageMeta(PAGE_META)
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.isLoading = true
      this.me = await getMe()
      this.isLoading = false
    },
  },
})
